import { useGeoLookupContext } from '@/hooks/useGeoLookupContext';
import { config } from '@/pageConfig/pet/pet/us/a-sticky-header-check-our-prices';
import { PetPageTemplate } from '@/pageTemplate/PetPageTemplate';
import { useEffect } from 'react';

export default function PetPage() {
  const { trackEventWithGeolocation } = useGeoLookupContext();

  // biome-ignore lint/correctness/useExhaustiveDependencies: want to track event only once
  useEffect(
    () =>
      trackEventWithGeolocation('pet_landing_page.viewed', {
        experiment: 'a-sticky-header-check-our-prices',
      }),
    [],
  );

  return <PetPageTemplate config={config} />;
}
